import { ChangeDetectionStrategy, Component, HostBinding, Signal, computed, input } from '@angular/core';

type Size = 'default' | 'large';

@Component({
    selector: 'lib-avatar',
    templateUrl: './avatar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AvatarComponent {
	@HostBinding('style') style = 'display: block';

	public readonly size = input<Size>('default');
	public readonly name = input.required<string>();
	public readonly src = input.required<string>();
	public readonly borderRadius = input<number>(0);

	public readonly calculatedSize: Signal<45 | 150> = computed(() => {
		if (this.size() === 'default') {
			return 45;
		}
		if (this.size() === 'large') {
			return 150;
		}

		return 45;
	});
}
